/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './countdown-root.html';

import { mixinType } from '../../util.type';

// TODO neumí reagovat na změny v prop end
// TODO není ošetřeno na nevyplnění a nevalidní vstupy (např. -1)
// TODO vždy emitovat end při změně v prop end
// http://fareez.info/blog/countdown-timer-using-vuejs/
// http://flipclockjs.com/
export default defineComponent({
  name: 'CountdownRoot',
  template,
  data() {
    return mixinType(
      {
        remaining: 0
      },
      /**
       * @type {{
       *   endTimeout: ReturnType<typeof setTimeout> | undefined;
       *   tickInterval: ReturnType<typeof setInterval> | undefined;
       * }}
       */
      ({})
    );
  },
  destroyed() {
    this.stop();
  },
  emits: {
    end() {}
  },
  methods: {
    getDelay() {
      return this.end - Date.now();
    },
    onEnd() {
      this.endTimeout = undefined;
      clearInterval(this.tickInterval);
      this.tickInterval = undefined;
      this.onTick();
      this.$emit('end');
    },
    onTick() {
      const delay = this.getDelay();
      this.remaining = Math.max(0, Math.round(delay / 1000));
    },
    start() {
      if (this.endTimeout || this.tickInterval) {
        throw new Error('Already started.');
      }
      const delay = this.getDelay();
      this.endTimeout = setTimeout(this.onEnd, delay);
      this.tickInterval = setInterval(this.onTick, 1000);
      this.onTick();
    },
    stop() {
      clearTimeout(this.endTimeout);
      this.endTimeout = undefined;
      clearInterval(this.tickInterval);
      this.tickInterval = undefined;
    }
  },
  mounted() {
    this.start();
  },
  props: {
    // TODO mohl by podporovat více vstupních typů (String, Date?)
    end: { type: Number, required: true }
  },
  watch: {
    end() {
      this.stop();
      this.start();
    }
  }
});
